export const LAYOUT_CHANGED = 'settings/LAYOUT_CHANGED';
export const layoutChanged = payload => ({
  type: LAYOUT_CHANGED,
  payload,
});



// WEBPACK FOOTER //
// ./app-settings/actions/layout-changed.js